/** Mirrors the backend `ConditionOperator`. */
export enum ConditionOperatorEnum {
  IS = 'is',
  IS_NOT = 'is_not',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  IS_ANY_OF = 'is_any_of',
  IS_CHECKED = 'is_checked',
  IS_NOT_CHECKED = 'is_not_checked',
  CONTAINS = 'contains',
  IS_EMPTY = 'is_empty',
  IS_NOT_EMPTY = 'is_not_empty',
}
